import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../app/providers/StoreProvider/config/StateSchema'
import { saveAuthTokens } from '../../../../shared/lib/helpers/authStorage'
import { UserActions } from '../../../../entities/User/model/slices/UserSlice'
import { AuthResponse } from '../../../../entities/User/model/types/UserSchema'

interface LoginProps {
    username: string
    password: string
}

export const loginByUsername = createAsyncThunk<
    AuthResponse,
    LoginProps,
    ThunkConfig<string>
>(
    'AuthByUsername/loginByUsername',
    async ({ username, password }, thunkApi) => {
        const { extra, dispatch, rejectWithValue } = thunkApi

        try {
            const response = await extra.api.post<AuthResponse>('/auth/login', {
                username,
                password
            })

            saveAuthTokens(response.data.access_token, response.data.refresh_token)
            dispatch(UserActions.setUser(response.data.user))
            dispatch(UserActions.setAuth(true))

            return response.data
        } catch (e: any) {
            const message = e.response?.data?.message
            const errorText = Array.isArray(message)
                ? message[0]
                : message || 'Неверное имя пользователя или пароль'

            return rejectWithValue(errorText)
        }
    }
)
